// Helper function to merge configs recursively
export function mergeConfigs(target, source) {
    if (!source)
        return target;
    if (!target)
        return source;
    const result = { ...target };
    for (const key in source) {
        if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) {
            result[key] = mergeConfigs(result[key] || {}, source[key]);
        }
        else if (source[key] !== undefined) {
            result[key] = source[key];
        }
    }
    return result;
}
